import { selectors } from 'modules/common';
import { domain, State } from 'modules/data';

import { changeRequestDescription, changeRequestName, uploadAttachments } from '../../actions';
import { getContext, getRequest, getShowValidationErrors } from '../../selectors/pageSelectors';

export function mapStateToProps(state: State) {
    const request = getRequest<domain.StandaloneRequest>(state);

    return {
        templateName: request.template.text,
        name: request.details.name,
        description: request.details.description,
        context: getContext(state),
        showValidationErrors: getShowValidationErrors(state),
        company: selectors.company.getCompanyById(state, request.companyId),
    };
}

export const mapDispatchToProps = {
    uploadAttachments,
    changeRequestName,
    changeRequestDescription,
};
